import { EmailSystemIcon, PhoneSystemIcon } from '@nib/icons';
import { getBaseUrl } from './utils';
const PHONE_NUMBER = '1800 999 333';
const EMAIL = 'enquiries@nibthrive.com.au';
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';
const CDN_BASEURL = 'https://static.nib.com.au/images/nib/mds/footer';
// Logos are being rendered with a height of 64px so just the small png (128px tall) is suitable
// SVG files are a bit crisp for some reason...
const IMAGE_PATHS = {
  I_HEART_NDIS: {
    SVG: `${CDN_BASEURL}/iHeartNDIS.svg`,
    SMALL: `${CDN_BASEURL}/iHeartNDIS@1x.png`,
    LARGE: `${CDN_BASEURL}/iHeartNDIS@2x.png`
  },
  DIA_MEMBER: {
    SVG: `${CDN_BASEURL}/DIAMember.svg`,
    SMALL: `${CDN_BASEURL}/DIAMember@1x.png`,
    LARGE: `${CDN_BASEURL}/DIAMember@2x.png`
  },
  NDS_ASSOCIATE: {
    SVG: `${CDN_BASEURL}/NDSAssociate.svg`,
    SMALL: `${CDN_BASEURL}/NDSAssociate@1x.png`,
    LARGE: `${CDN_BASEURL}/NDSAssociate@2x.png`
  }
};
export const facebook = {
  key: 'Facebook',
  id: 'ga-footer-thrive-facebook',
  title: 'Like nib Thrive on Facebook',
  url: 'https://www.facebook.com/nibthrive'
};
export const instagram = {
  key: 'Instagram',
  id: 'ga-footer-thrive-instagram',
  title: 'Follow nib Thrive on Instagram',
  url: 'https://www.instagram.com/nibthrive'
};
const getThriveConfig = config => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-thrive',
    columns: [{
      id: 'ga-footer-thrive-helpful-links',
      title: 'Helpful links',
      children: [{
        id: 'ga-footer-thrive-kynd',
        title: 'Find and book support through Kynd',
        url: 'https://kynd.com.au/?utm_source=nibthrive&utm_medium=referral&utm_campaign=nibthrive&utm_content=footer'
      }, {
        id: 'ga-footer-thrive-participant-handbook',
        title: 'Thrive Participant Handbook',
        url: `${baseUrl}/docs/thrive-participant-handbook`
      }, {
        id: 'ga-footer-thrive-service-agreement',
        title: 'nib Thrive Plan Management Service Agreement',
        url: `${baseUrl}/docs/thrive-service-agreement`
      }, {
        id: 'ga-footer-thrive-plan-management-login',
        title: 'Plan management login',
        url: 'https://gateway.nibthrive.com.au/'
      }]
    }],
    contact: {
      heading: 'Get in touch',
      contactLinks: [{
        id: 'ga-footer-thrive-phone',
        title: PHONE_NUMBER,
        url: `tel:${PHONE_NUMBER.replace(/\s+/g, '')}`,
        icon: PhoneSystemIcon
      }, {
        id: 'ga-footer-thrive-email',
        title: EMAIL,
        url: `mailto:${EMAIL}`,
        icon: EmailSystemIcon
      }],
      socialLinks: [facebook, instagram],
      associations: [{
        name: 'I love NDIS',
        src: IMAGE_PATHS.I_HEART_NDIS.SMALL,
        alt: 'I love NDIS logo'
      }, {
        name: 'Disability Intermediaries Australia member',
        src: IMAGE_PATHS.DIA_MEMBER.SMALL,
        alt: 'Disability Intermediaries Australia member logo'
      }, {
        name: 'National Disability Services associate',
        src: IMAGE_PATHS.NDS_ASSOCIATE.SMALL,
        alt: 'National Disability Services associate logo'
      }]
    },
    smallFooterConfig: {
      id: 'small-footer-thrive',
      phoneNumber: PHONE_NUMBER,
      links: [{
        id: 'ga-footer-thrive-terms',
        title: 'Terms and Conditions',
        url: `${baseUrl}/docs/thrive-terms-and-conditions`
      }, {
        id: 'ga-footer-thrive-privacy',
        title: 'Privacy Policy',
        url: `${baseUrl}/docs/thrive-privacy-policy`
      }],
      copyrightText: `nib Thrive is an NDIS Registered Plan Management Provider\nProvider Registration Number: 4050033778`
    }
  };
};
export default getThriveConfig;